import React from 'react';
import { styled } from '@material-ui/core/styles';

const StyledProductName = styled(({ ...props }) =>
  <span {...props}>Canvass</span>
)({
  fontFamily: 'Poppins, sans-serif',
});

export default StyledProductName;